import { LitElement, html, Splide, animationHelpers } from '@hh/global.js'
import { scrollToSmoothly } from './utils.js'

export class ContentStickyNav extends LitElement {
  static properties = {
    sectionId: {
      typeof: 'String',
    },
  }

  connectedCallback() {
    super.connectedCallback()

    this.initLinks()
    this.initSlider()
    this.checkOnEvent()

    window.addEventListener('scroll', this.checkOnEvent.bind(this))
    window.addEventListener('resize', this.checkOnEvent.bind(this))
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('scroll', this.scrollCheck.bind(this))
  }

  checkOnEvent() {
    this.topCheck()
    this.scrollCheck()
  }

  topCheck() {
    this.siteHeader = document.querySelector('[data-header-wrapper]')
    this.parent = document.querySelector(`#shopify-section-${this.sectionId}`)

    if (!parent || !this.siteHeader) return null

    this.parent.style.setProperty('--top-pos', `${this.siteHeader.offsetHeight}px`)
  }

  scrollCheck() {
    const sections = this.sectionTargets ?? []
    let mostScrollThroughPercent = null
    let activeSlideLink = null
    let activeLinkIndex = null

    sections.forEach((section, index) => {
      const scrollPercent = animationHelpers.scrollThroughPercentage(section)
      const slideLink = this.slideLinks[index]
      slideLink?.classList.remove('active')

      if (
        index !== 0 &&
        (scrollPercent == null ||
          scrollPercent < 0 ||
          (mostScrollThroughPercent !== null &&
            mostScrollThroughPercent < scrollPercent))
      ) {
        return null
      }

      activeSlideLink = slideLink
      activeLinkIndex = index
      mostScrollThroughPercent = scrollPercent
    })

    activeSlideLink?.classList.add('active')
    if (activeLinkIndex !== null) {
      this.slider?.go(activeLinkIndex)
    }
  }

  initLinks() {
    this.slideLinks = this.querySelectorAll('[data-slide-link]')
    this.sectionTargets = [...this.slideLinks].reduce((targets, slideLink) => {
      const targetId = slideLink.href.split('#').pop()
      const linkSectionTarget = document.getElementById(`${targetId}`)
      slideLink.addEventListener('click', (event) =>
        this.clickLink(event, linkSectionTarget)
      )
      targets.push(linkSectionTarget)
      return targets
    }, [])
  }

  clickLink(event, linkSectionTarget) {
    if (!linkSectionTarget) {
      return null
    }
    event.preventDefault()

    const currentScrollTop = document.documentElement.scrollTop
    const scrollToPos = animationHelpers.scrollIndexFromPercentage(
      linkSectionTarget,
      1,
      0
    )

    const topPos =
      currentScrollTop < scrollToPos
        ? scrollToPos - this.offsetHeight
        : scrollToPos - this.offsetHeight - this.siteHeader.offsetHeight
    scrollToSmoothly(topPos, 500)
  }

  initSlider() {
    const sliderHolder = this.querySelector('[data-slider-holder]')
    if (!sliderHolder) {
      return null
    }

    this.slider = new Splide(sliderHolder, {
      type: 'slide',
      arrows: false,
      pagination: false,
      autoplay: false,
      pauseOnHover: false,
      perPage: 1,
      autoWidth: true,
      useScroll: true,
      drag: 'free',
      autoWidth: true,
      snap: false,
      trimSpace: true,
    })

    this.slider.mount()
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('content-sticky-nav', ContentStickyNav)
